import React from 'react';

import PropTypes from "prop-types";

import { TextField } from '@mui/material';

const QualificationTextField = ({ value, onChange, name, style, ...other }) => {

    const [currentValue, setCurrentValue] = React.useState(value);

    const [pause, setPause] = React.useState(null);

    const handleChange = (event) => {
        setCurrentValue(event.target.value);
        clearTimeout(pause);
        setPause(setTimeout(() => onChange({ target: { name: name, value: event.target.value } }), 250));
    };


    const handleBlur = () => {
        if (currentValue !== value) {
            onChange({ target: { name: name, value: currentValue } });
        }
    };

    return (
        <TextField style={style}
            fullWidth
            variant="outlined"
            InputLabelProps={{
                shrink: true
            }}

            value={currentValue}
            onChange={handleChange}
            onBlur={handleBlur}

            {...other}
        >
            {other.children}


        </TextField>
    )
};

QualificationTextField.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    style: PropTypes.object,
};

QualificationTextField.defaultProps = {
    style: { paddingBottom: '8px' },
};

export default QualificationTextField;